import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { ItemObject } from 'src/app/models/orders/item/item-object.model';
import { OrdersRouterService } from 'src/app/services/api/router/orders-router.service';
import { TabObject } from 'src/app/models/orders/item/tab-object.model';
import { TabListObject } from 'src/app/models/orders/item/tab-list-object.model';
import { TabIndexObject } from 'src/app/models/orders/item/tab-index-object.model';
import { OrdersService, OrderSummary } from 'src/app/services/api/orders/orders.service';
import { OrderTypeObject } from 'src/app/models/orders/order-type-object.model';
import { Product } from 'src/app/models/interface/product/product';
import { IpService, ServiceIpInfoResponse } from 'src/app/services/api/ip/ip.service';
import { NotificationLevel, NotificationsService } from 'src/app/services/api/notifications/notifications.service';
import { ProductService } from 'src/app/services/api/product/product.service';
import { TranslateService } from '@ngx-translate/core';
import { MatDialog } from '@angular/material';
import { IpListComponent } from 'src/app/layout/products/search-products/product-detail/product-tabs/product-depth-level/product-depth-level-rfs/product-depth-level-rfs-actions/ip-list/ip-list.component';

@Component({
  selector: 'app-order-rfs',
  templateUrl: './order-rfs.component.html',
  styleUrls: ['./order-rfs.component.scss']
})
export class OrderRfsComponent implements OnInit {

  @Input() summary: OrderSummary;
  @Input() params: any;
  @Input() isps: any[];

  @Output() cancelOrderEvent = new EventEmitter();

  private tabList: TabListObject;
  selectedIndex;

  item: Product;
  inventoryId: string;

  constructor(private routerService: OrdersRouterService,
    private ipService: IpService,
    private notificationsService: NotificationsService,
    private ordersService: OrdersService,
    private productService: ProductService,
    private translateService: TranslateService,
    private dialog: MatDialog) {

  }

  ngOnInit() {
    this.tabList = new TabListObject();
    this.tabList.add(new TabIndexObject(0, TabObject.GENERAL_TAB));
    this.tabList.add(new TabIndexObject(1, TabObject.SERVICE_TAB));
    this.tabList.add(new TabIndexObject(2, TabObject.STATES_TAB));
    this.tabList.add(new TabIndexObject(3, TabObject.PROCESSES_TAB));
    this.tabList.add(new TabIndexObject(4, TabObject.SITES_TAB));
    this.tabList.add(new TabIndexObject(5, TabObject.DEPENDENCIES_TAB));
    this.tabList.add(new TabIndexObject(6, TabObject.RESOURCE_TAB));

    switch (this.params.tab) {
      case 'general':
        this.selectedIndex = 0;
        break;
      case 'service':
        this.selectedIndex = 1;
        break;
      case 'states':
        this.selectedIndex = 2;
        break;
      case 'processes':
        this.selectedIndex = 3;
        break;
      case 'sites':
        this.selectedIndex = 4;
        break;
      case 'dependencies':
        this.selectedIndex = 5;
        break;
      case 'resource':
        this.selectedIndex = 6;
        break;
      default:
        this.selectedIndex = 0;
        break;
    }
    this.ordersService.getProductOrderSummaryFromServiceRef(this.summary.id).subscribe(
      (data) => {
        this.inventoryId = data.inventoryId;
        this.getProductInfo(data.inventoryId);
      },
      (error) => {
        this.notificationsService.showNotification(this.translateService.instant('INSTALLATION_STATUS.productError'), NotificationLevel.ERROR);
      }
    )
  }

  public goToTab($event): void {
    const tab: TabObject = this.tabList.getTab($event.index);

    this.routerService.navigate(new ItemObject(this.params.id, this.params.map, OrderTypeObject.RFS, tab));

  }

  cancelOrder() {
    this.cancelOrderEvent.emit();
  }

  isAMMRFS() {
    return this.summary.specification.includes('RFS_Adamo_Mobile_MasMovil');
  }

  isAnInstallationRFS() {
    return this.summary.specification.includes('RFS_FTTH_Installation');
  }

  isAnIpInventoryRFS() {
    return this.summary.specification.includes('RFS_FTTH_IPInventory');
  }

  ipList() {
    const remoteId = this.item.cfses[0].cfsCharValues.find(charValue => charValue.specId == "sc_network_remote_id").value;
    this.productService.getProduct(this.inventoryId).subscribe(
      (data: Product) => {
        this.item = data;
        this.ipService.getIpList(remoteId).subscribe(
          (data: ServiceIpInfoResponse) => {
            const matDialogRef = this.dialog.open(IpListComponent,
              {
                data: { ipInfo: data, item: this.item },
                minWidth: "50%",
                height: "100%",
                restoreFocus: false,
                autoFocus: false,
                disableClose: true
              })
            matDialogRef.afterClosed().subscribe((item: Product) => {
              this.item = item;
            });
          },
          (error) => {
            this.notificationsService.showNotification(this.translateService.instant('IP_LIST.list_error'), NotificationLevel.ERROR);
          }
        );
      },
      (error) => {
        this.notificationsService.showNotification(this.translateService.instant('PRODUCTS_KEY.infoError'), NotificationLevel.ERROR);
      }
    )
  }

  getProductInfo(inventoryId: string) {
    this.productService.getProduct(inventoryId).subscribe(
      (data: Product) => {
        this.item = data;
      },
      (error) => {
        this.notificationsService.showNotification(this.translateService.instant('PRODUCTS_KEY.infoError'), NotificationLevel.ERROR);
      }
    )
  }

}
